<div class="wccard p-3 mb-1">
    <app-companypage-ai [requestaidata]="schoolsdataAI" [hasMedianSalary]="!isRecentGraduateData" [currentCompanyName]="currentCompanyName" [insightstabname]="'education'" [totalcount]="totalResultCount" ></app-companypage-ai>
</div>
<div class="wccard p-3 mb-3">
    <p class="f-16 mb-6 font-weight-600" *ngIf="!showSchoolLoader">Schools producing talent for {{currentCompanyName | titlecase}}</p>

    <div>
        <div *ngIf="!school.data?.length">
            <div class="loader text-center" *ngIf="showSchoolLoader && !schoolemptystate">
                <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
            </div>
            <div class="text-center" *ngIf="!showSchoolLoader && schoolemptystate">
                <p class="text-center small p-5 text-484b59">No Data Available</p>
            </div>
        </div>


        <table mat-table *ngIf="school.data?.length" [dataSource]="school" class="mat-elevation-z8" style="width: 100%; box-shadow: none;" matSort #educationTbSort="matSort" (matSortChange)="manualSort()">

            <!-- key -->
            <ng-container matColumnDef="key">
                <th mat-header-cell mat-header-cell *matHeaderCellDef  class="col-4">
                    <p class="text-9696 f-12 m-0">{{tableHeaderObj["Schools"]}}</p>
                </th>
                <td class="col-4 text-484b59" mat-cell *matCellDef="let element" style="font-family: 'Poppins', sans-serif;">
                    {{element.key | titlecase}}
                </td>
            </ng-container>

             <!-- doc_count -->
             <ng-container matColumnDef="doc_count">
                <th class="col-2 text-center" mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by doc count" >
                    <p class="text-9696 f-12 m-0">{{tableHeaderObj["TalentCount"]}}</p>
                </th>
                <td class="col-2 font-weight-600 text-484b59" mat-cell *matCellDef="let element">
                    <span class="pointer" (click)="handelRedirection('school', element.key)">{{element.doc_count | number}}</span>
                </td>
            </ng-container>

            <!-- recentGraduate -->
            <ng-container matColumnDef="recentGraduate">
                <th class="col-2 text-center" mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by doc count" >
                    <p class="text-9696 f-12 m-0">{{tableHeaderObj["RecentGraduate"]}}</p>
                </th>
                <td class="col-2 text-484b59" mat-cell *matCellDef="let element" class="">
                    <div *ngIf="!isRecentGraduateData" class="spinner-border position-absolute text-black" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                      <p class=" text-484b59 font-weight-600"><span class="pointer" (click)="handelRedirection('recentgraduatesonly', element.key)">{{element.recentGraduate | number}}</span></p>

                </td>
            </ng-container>

            <!-- graph -->
            <ng-container matColumnDef="graph">
                <th class="text-center col-4" mat-header-cell *matHeaderCellDef mat-sort-header="graph"
                    sortActionDescription="Sort by percentage">
                    <p class="text-9696 f-12 m-0">{{tableHeaderObj["%OfTotal"]}}</p>
                </th>
                <td class="col-4" mat-cell *matCellDef="let element">
                    <div class="progress d-flex align-items-center" style="height: 12px!important;">
                        <span class="mr-1 text-484b59">
                            {{getSchoolPercentage(element.doc_count)}}%
                        </span>
                        <span class="progress-bar" role="progressbar" style="background-color: #2E93A1 !important;" [ngStyle]="{'width.%': getSchoolPercentage(element.doc_count)}" aria-valuenow="getSchoolPercentage(element.doc_count)" aria-valuemin="0" aria-valuemax="100"></span>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

    </div>
    <div class="d-flex justify-content-center wccard ng-star-inserted" *ngIf="totalCount > 5">
        <ngb-pagination [collectionSize]="totalCount" [maxSize]="5" aria-label="Custom pagination" [pageSize]="pageSize" rotate="false" (pageChange)="setPage($event)" [(page)]="currentPage" [ellipses]="false" [boundaryLinks]="false"
  [directionLinks]="false">
        </ngb-pagination>
    </div>
</div>

<div class="wccard p-3 mb-3">
    <p class="f-16 font-weight-600 mb-6" *ngIf="education?.data?.length && !showEducationLoader">
        What qualifications do the talent have at {{currentCompanyName | titlecase}}?
    </p>
    <div class="text-center">
        <div *ngIf="!education?.data?.length">
            <div class="loader text-center" *ngIf="showEducationLoader && !qualificationemptystate">
                <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
            </div>
            <div class="text-center" *ngIf="!showEducationLoader && qualificationemptystate">
                <p class="text-center small p-5 text-484b59">No Data Available</p>
            </div>
        </div>

        <div class="col wccard"  *ngIf="education?.data?.length">
            <fusioncharts width="100%" height="450" type="column2d" [dataSource]="education">
            </fusioncharts>
        </div>
    </div>
</div>

<div class="wccard p-3 mb-3">
    <p class="f-16 font-weight-600 mb-6" *ngIf="fieldOfStudy?.data?.length && !showFieldOfStudyLoader">
        Fields of study for talent at {{currentCompanyName | titlecase}}
    </p>
    <div class="row">
        <div class="col">
            <div *ngIf="!fieldOfStudy?.data?.length">
                <div class="loader text-center" *ngIf="showFieldOfStudyLoader && !fieldofstudyemptystate">
                    <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                </div>
                <div class="text-center" *ngIf="!showFieldOfStudyLoader && fieldofstudyemptystate">
                    <p class="text-center small p-5">No Data Available</p>
                </div>
            </div>

            <fusioncharts width="100%" height="450" type="bar2d" [dataSource]="fieldOfStudy" *ngIf="fieldOfStudy?.data?.length">
            </fusioncharts>
        </div>
    </div>

</div>
